// Losing the connection: the machine chip says it (RECONNECTING, OFFLINE) and its card explains it, so nothing floats
// over the panes. A blip says nothing; once it was lost for a second or more, a toast says when it's back.

import { useEffect, useRef, useState } from 'react';
import { machineName, toast, useStore } from '../store';

const RECONNECT_AFTER_MS = 1000;

/** The browser has no network (navigator.onLine): the connection can't come back until it does. */
export function useOffline(): boolean {
  const [off, setOff] = useState(() => typeof navigator !== 'undefined' && navigator.onLine === false);
  useEffect(() => {
    const sync = () => setOff(navigator.onLine === false);
    addEventListener('online', sync);
    addEventListener('offline', sync);
    return () => {
      removeEventListener('online', sync);
      removeEventListener('offline', sync);
    };
  }, []);
  return off;
}

export function ConnectionNotice() {
  const c = useStore((s) => s.conn);
  const offline = useOffline();
  const [late, setLate] = useState(false);
  const lost = useRef(false);

  useEffect(() => {
    if (c !== 'reconnecting') {
      setLate(false);
      return;
    }
    const t = setTimeout(() => setLate(true), RECONNECT_AFTER_MS);
    return () => clearTimeout(t);
  }, [c]);

  const kind = offline ? 'offline' : late && c === 'reconnecting' ? 'reconnecting' : null;
  useEffect(() => {
    if (kind) lost.current = true;
    else if (lost.current && c === 'connected') {
      lost.current = false;
      toast({ key: 'conn', title: `Back on ${machineName()}` }, 3000);
    }
  }, [kind, c]);

  return null;
}
